export default __webpack_public_path__ + "static/media/sciaticaOne.5f9caa2d.png";